"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewerOptions = exports.ViewType = void 0;
const config_1 = require("../config");
const assetVersionType_1 = require("../enums/assetVersionType");
var ViewType;
(function (ViewType) {
    ViewType["LIGHT"] = "light";
    ViewType["FULL"] = "full";
})(ViewType = exports.ViewType || (exports.ViewType = {}));
class ViewerOptions {
    static override(options) {
        if (!options)
            return;
        if (options.assetVersionType) {
            if (!Object.values(assetVersionType_1.AssetVersionType).includes(options.assetVersionType)) {
                throw new Error("Viewer initialization optional value for assetVersionType is not supported: " + options.viewType);
            }
            ViewerOptions.assetVersionType = options.assetVersionType;
        }
        if (options.tokenProvider) {
            ViewerOptions.tokenProvider = options.tokenProvider;
        }
        if (options.autoload) {
            ViewerOptions.autoload = options.autoload;
        }
        if (!options.showEmbedIcon) {
            ViewerOptions.showEmbedIcon = options.showEmbedIcon == undefined ? true : options.showEmbedIcon;
        }
        // Viewer type
        if (options.viewType) {
            if (!Object.values(ViewType).includes(options.viewType)) {
                throw new Error("Viewer initialization optional value for viewType is not supported: " + options.viewType);
            }
            ViewerOptions.viewType = options.viewType;
        }
        // Language
        if (options.language) {
            if (!config_1.config.language.supported.find((lang) => { return lang[0] === options.language; })) {
                throw new Error("Viewer initialization optional value for language is not supported: " + options.language);
            }
            ViewerOptions.language = options.language;
        }
        // Background
        if (options.backgroundColor) {
            var regExp = /([0-9A-F]{6}$)|([0-9A-F]{3}$)/i;
            if (!regExp.test(options.backgroundColor)) {
                throw new Error("Viewer initialization optional value for backgroundColor is not supported: " + options.backgroundColor);
            }
            if (options.backgroundColor[0] !== '#') {
                ViewerOptions.backgroundColor = "#" + options.backgroundColor;
                return;
            }
            ViewerOptions.backgroundColor = options.backgroundColor;
        }
    }
}
exports.ViewerOptions = ViewerOptions;
ViewerOptions.assetVersionType = assetVersionType_1.AssetVersionType.PUBLISHED;
ViewerOptions.autoload = false;
ViewerOptions.viewType = ViewType.LIGHT;
ViewerOptions.showEmbedIcon = true;
